module.exports = __webpack_public_path__ + "html/privacy_4b324e662dcfee78a76a75663c189aae.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/privacy.html
// module id = 7zPr
// module chunks = 151